import {authFetch} from '../../utils/cloudFunctionsAuth'
import {Bill, Payment, RepeatingInvoice} from '../../types/accounting'

export type ReconciliationBill = Bill & {
  repeatingTemplateId?: string
  source?: string
  revision?: string
  amountCredited?: number
}
export type ReconciliationPayment = Payment & {bankReconciliationId?: string}
export type ReconciliationTemplate = RepeatingInvoice & {revision: string}
export interface Reconciliation {
  id: string
  transactionId: string
  status: 'confirmed' | 'reversed'
  allocations: {billId: string; paymentId: string; amount: number; createdPayment: boolean}[]
  scheduleChanges: {templateId: string; before: {nextDate: string}; after: {nextDate: string}}[]
  billChanges?: {billId: string; before: Record<string, any>; after: Record<string, any>}[]
  createdTemplateId?: string | null
}
export interface ReconciliationData {
  bills: ReconciliationBill[]
  payments: ReconciliationPayment[]
  templates: ReconciliationTemplate[]
  reconciliations: Reconciliation[]
  asOf: string
}
export interface MatchSuggestion {
  billId: string
  paymentId: string | null
  score: number
  reasons: string[]
  strength: string
}
export async function bankRequest(
  action: string,
  payload: Record<string, unknown> = {}
): Promise<any> {
  const res = await authFetch(
    'https://us-central1-web-construct-app.cloudfunctions.net/bankReconciliationHttp',
    {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({action, ...payload}),
    }
  )
  const data = await res.json().catch(() => ({}))
  if (!res.ok || !data.ok)
    throw new Error(data.error || 'Cashflow could not connect. Please try again.')
  return data
}
